import {environment} from "../environments/environment";
import { ConfigService } from "./configServices";

export function ConfigLoader(configService: ConfigService) {
  return () => configService.load(environment.configFile);
}